import volumetricPrinting from "./templates/volumetric-printing";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `<h3>Чехол для iPhone 7 Plus, объёмная печать</h3><p>Чехол изготавливается из силикона с покрытием soft touch.</p><p>Размеры: 160х80 мм.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${volumetricPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
